import React, { useState } from "react";
import { Box, CssBaseline, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import AppBarComponent from "./Header/Header";
import DrawerComponent from "./Sidebar/SidebarDrawer";
// import useNavigationBlocker from "@/Utils/Rules/useNavigationBlocker"

const drawerWidth = 240;

export default function SidebarLayout() {
  const [drawerOpen, setDrawerOpen] = useState(true);
  // const [isFormDirty, setIsFormDirty] = useState(false); // 👈 track unsaved changes

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  // 👇 Block navigation if form is dirty
  // useNavigationBlocker(isFormDirty, "You have unsaved changes. Do you really want to leave this page?");

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      <CssBaseline />
      <AppBarComponent onToggleDrawer={toggleDrawer} />
      <DrawerComponent drawerOpen={drawerOpen} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          overflowX: "hidden",
          overflowY: "auto",
          backgroundColor: "var(--brand-100)",
          p: 2,
          height: "100vh",
        }}
      >
        <Toolbar />
        <Outlet
        //  context={{ setIsFormDirty }} 
         /> {/* 👈 pass state to child forms */}
      </Box>
    </Box>
  );
}
